module.exports = __webpack_public_path__ + "img/tool.ce0f6d38.svg";